import React, { useEffect, useState } from "react";
import RenderLayout from "./RenderLayout";
import { Box, Button } from "@chakra-ui/react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Img3 from "../../../../../assets/Img3.png";
import SingleCard from "../SiteFeasibility/SingleCard";
import axios from "axios";
import {
  getAxiosConfig,
  getMinioImage,
  getUpdatedImageUrlWithSize,
} from "../../../../../utils/helpers";
import MasonaryWrapper from "../../../../../components/MasonaryWrapper";
import { useFormContext } from "../FormStateContext";

function ThreeDRender({
  activeTab,
  data,
  setActiveTab,
  isRandom,
  fetchPresentationData,
  handlePublicLink,
  handleClose,
  fetchPresentationDataApi,
  duplicatePresentation,
}) {
  const { setTab } = useFormContext();
  console.log({ data });
  return (
    <div className="w-full">
      {/* <RenderLayout /> */}
      {activeTab.index == 2 && activeTab.showForm ? (
        <RenderLayout
          handlePublicLink={handlePublicLink}
          isRandom={isRandom}
          isEdit={activeTab?.isEditId}
          data={data}
          setActiveTab={() =>
            setActiveTab((p) => ({
              // showForm: false,
              ...p,
              index: 2,
              isEditId: null,
              isRender: !p?.isRender,
            }))
          }
          storeActiveTab={
            () => setTab(activeTab)
            // sessionStorage.setItem('activetab', JSON.stringify(activeTab))
          }
        />
      ) : (
        <MasonaryWrapper>
          {data &&
            data?.length > 0 &&
            data.map((item, index) => (
              <SingleCard
                duplicatePresentation={duplicatePresentation}
                images={[Img3, Img3, Img3, Img3]}
                label={"3D Render"}
                key={item?._id || index}
                data={data?.[index]}
                isRandom={isRandom}
                fetchPresentationData={fetchPresentationData}
                handlePublicLink={() =>
                  handlePublicLink(`render/${item?._id}/${item?.companyName}`)
                }
                //  handleClose={handleClose}

                activeTabIdx={activeTab?.index}
                randomImages={
                  isRandom
                    ? item.areas
                        .map((v) => [
                          ...v.areaImage.map((i) =>
                            getUpdatedImageUrlWithSize(
                              getMinioImage(i, true),
                              [1, 1, 2],
                            ),
                          ),
                          // ...v.internalImages,
                        ])
                        .flat() || []
                    : []
                }
                handleEdit={(id) =>
                  setActiveTab({ showForm: true, index: 2, isEditId: id })
                } // Set the active tab to 3D Render
              />
            ))}
        </MasonaryWrapper>
      )}
      {/* <Button
        width={"100%"}
        type="button"
        className={
          "text-white bg-green-500 hover:bg-green-600 py-2 px-4 rounded-lg disabled:bg-slate-400 disabled:cursor-not-allowed "
        }
        colorScheme="teal"
        leftIcon={<Icon className="text-lg" icon="fluent:add-48-filled" />}
        variant={"outline"}
      >
        Create New Area Plan
      </Button> */}
    </div>
  );
}

export default ThreeDRender;
